import React, { useState, useEffect } from "react";
import { Grid, Card, Button, Icon } from "tabler-react";
import SiteWrapper from "../../../SiteWrapper.react";
import Crud_Catalogos from "../../../herramientas/Crud_Catalogos";
import TablePageable from "../../../Helpers/TablePageable.react";
import TableSkeleton from "../../../components/TableSkeleton/TableSkeleton";
import jsPDF from "jspdf";

function getSessionData(key) {
  try { return JSON.parse(sessionStorage.getItem(key)); } catch (e) { return null; }
}

const GpsDevolucionPage = () => {
  const [gpsList, setGpsList] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [generandoPdf, setGenerandoPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfNombre, setPdfNombre] = useState("");

  useEffect(() => {
    document.body.style.overflow = pdfUrl ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [pdfUrl]);

  useEffect(() => {
    obtenerTransportistas();
  }, []);

  const obtenerTransportistas = () => {
    const usuario = getSessionData("usuario");
    const currentUser = getSessionData("currentUser");
    if (!usuario || !currentUser) { setCargando(false); return; }

    const plataformasIds = [...new Set(currentUser.map(c => c.plataforma?.id).filter(Boolean))];
    const promesas = plataformasIds.map(idPlat =>
      Crud_Catalogos("usuarios_transportistas/usuario/" + usuario.id + "/plataforma/" + idPlat, "", "get", "", [], "", "", "", []).catch(() => [])
    );

    Promise.all(promesas).then((resultados) => {
      const todos = resultados.flat();
      const ids = [...new Set(todos.filter(t => t.idTransportista !== null).map(t => t.idTransportista))];
      if (ids.length > 0) {
        cargarGps(ids);
      } else {
        setCargando(false);
      }
    }).catch(() => setCargando(false));
  };

  const cargarGps = (ids) => {
    setCargando(true);
    Crud_Catalogos("gps/dash/por_recuperar/transportistas/" + ids.join(",") + "/detalle", "", "get", "", [], "", "", "", [])
      .then((data) => {
        const lista = (Array.isArray(data) ? data : []).map(item => {
          let dias = "Sin fecha";
          const raw = item.endDateFormatted || item.endDate;
          if (raw) {
            const fecha = new Date(raw);
            if (!isNaN(fecha.getTime())) {
              dias = Math.floor((new Date() - fecha) / (1000 * 60 * 60 * 24));
            }
          }
          return { ...item, diasSinRecuperar: dias };
        });
        setGpsList(lista.sort((a, b) => (typeof b.diasSinRecuperar === "number" ? b.diasSinRecuperar : -1) - (typeof a.diasSinRecuperar === "number" ? a.diasSinRecuperar : -1)));
        setCargando(false);
      })
      .catch(() => setCargando(false));
  };

  const generarPdfEvidencia = (item) => {
    console.log("Generando PDF para item:", JSON.stringify(item));
    setGenerandoPdf(true);
    const movGpsId = item.idMovimientoGps;
    const nombrePdf = `Evidencia_GPS_${item.gps || item.idGps}.pdf`;

    Promise.all([
      Crud_Catalogos("getImagesMovGps/" + movGpsId + "/asignacion", "", "get", "", [], "", "", "", []).catch(() => []),
      Crud_Catalogos("gps_por_recuperar/id_gps/" + item.idGps, "", "get", "", [], "", "", "", []).catch(() => null)
    ]).then(([res, detalle]) => {
        console.log("Respuesta evidencia:", JSON.stringify(res));
        console.log("Detalle GPS:", JSON.stringify(detalle));
        const imagenes = Array.isArray(res) ? res : [];
        const itemCompleto = { ...item, ...detalle };
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 14;

        const logo = new Image();
        logo.onload = () => generarContenidoPdf(pdf, pageWidth, pageHeight, margin, imagenes, itemCompleto, nombrePdf, logo);
        logo.onerror = () => generarContenidoPdf(pdf, pageWidth, pageHeight, margin, imagenes, itemCompleto, nombrePdf, null);
        logo.src = "/images/logo.png";
      })
      .catch(() => { setGenerandoPdf(false); alert("No se encontró evidencia para este GPS."); });
  };

  const generarContenidoPdf = (pdf, pageWidth, pageHeight, margin, imagenes, item, nombrePdf, logo) => {
        let y = 0;

        // === HEADER con fondo ===
        pdf.setFillColor(55, 65, 81);
        pdf.rect(0, 0, pageWidth, 35, "F");
        if (logo) {
          pdf.addImage(logo, "PNG", margin, 5, 25, 25);
        }
        pdf.setFontSize(20);
        pdf.setFont(undefined, "bold");
        pdf.setTextColor(255, 255, 255);
        pdf.text("Evidencia GPS - Devolución", pageWidth / 2, 15, { align: "center" });
        pdf.setFontSize(10);
        pdf.setFont(undefined, "normal");
        pdf.text("Reporte generado: " + new Date().toLocaleString("es-MX"), pageWidth / 2, 25, { align: "center" });
        pdf.setTextColor(0, 0, 0);
        y = 45;

        // === Acento morado ===
        pdf.setFillColor(55, 65, 81);
        pdf.rect(0, 35, pageWidth, 2, "F");

        // === Tabla de datos ===
        pdf.setFontSize(12);
        pdf.setFont(undefined, "bold");
        pdf.setTextColor(55, 65, 81);
        pdf.text("Información del GPS", margin, y);
        pdf.setTextColor(0, 0, 0);
        y += 6;

        const formatFecha = (f) => { if (!f) return "N/A"; const d = new Date(f); return isNaN(d.getTime()) ? String(f) : d.toLocaleString("es-MX"); };
        const datos = [
          ["Días sin recuperar", String(item.diasSinRecuperar ?? "N/A")],
          ["GPS", item.gps || item.nombre || "N/A"],
          ["IMEI", item.imei || "N/A"],
          ["ID Último Mov.", String(item.idMovimiento || item.idMovimientoGps || "N/A")],
          ["Estatus", item.gpsEstatus || (item.idGpsEstatus?.nombre) || "N/A"],
          ["Plataforma", item.plataforma || (item.idPlataforma?.nombre) || "N/A"],
          ["Localidad", item.idLocalidad?.nombre || "N/A"],
          ["Cliente", item.cliente || (item.idCliente?.nombre) || "N/A"],
          ["Placa Remolque", item.remolquePlaca || "N/A"],
          ["Eco Remolque", item.economicor || "N/A"],
          ["Placa Tracto", item.tractorPlaca || "N/A"],
          ["Eco Tracto", item.economicot || "N/A"],
          ["Fecha Colocación", formatFecha(item.colocacionFecha)],
          ["Fin de Movimiento", formatFecha(item.endDateFormatted || item.endDate)],
          ["Última actividad", formatFecha(item.deviceactivityFormatted || item.deviceactivity)],
        ];
        const colW = (pageWidth - margin * 2) / 2;
        datos.forEach(([label, valor], i) => {
          const lines = pdf.splitTextToSize(valor, colW - 6);
          const rowH = Math.max(8, lines.length * 5 + 3);
          const fillColor = i % 2 === 0 ? [245, 245, 250] : [255, 255, 255];
          pdf.setFillColor(...fillColor);
          pdf.rect(margin, y, pageWidth - margin * 2, rowH, "F");
          pdf.setDrawColor(220, 220, 230);
          pdf.rect(margin, y, pageWidth - margin * 2, rowH, "S");
          pdf.setFontSize(9);
          pdf.setFont(undefined, "bold");
          pdf.text(label, margin + 3, y + 5.5);
          pdf.setFont(undefined, "normal");
          pdf.text(lines, margin + colW, y + 5.5);
          y += rowH;
        });

        y += 10;

        // === Sección de evidencia ===
        if (imagenes.length > 0) {
          pdf.setFontSize(12);
          pdf.setFont(undefined, "bold");
          pdf.setTextColor(55, 65, 81);
          pdf.text("Evidencia fotográfica (" + imagenes.length + " foto" + (imagenes.length > 1 ? "s" : "") + ")", margin, y);
          pdf.setTextColor(0, 0, 0);
          y += 8;

          const maxW = pageWidth - margin * 2;
          const maxH = pageHeight - y - 25;
          let loaded = 0;

          const addFooter = (p) => {
            pdf.setFontSize(8);
            pdf.setTextColor(150, 150, 150);
            pdf.text("Evidencia GPS - " + (item.gps || "N/A"), margin, pageHeight - 8);
            pdf.text("Página " + p + " de " + imagenes.length, pageWidth - margin, pageHeight - 8, { align: "right" });
            pdf.setTextColor(0, 0, 0);
          };

          const agregarImagen = (index) => {
            const imgSrc = "data:image/jpeg;base64," + imagenes[index];
            const img = new Image();
            img.onload = () => {
              if (index > 0) {
                addFooter(index);
                pdf.addPage();
                y = 15;
                pdf.setFontSize(10);
                pdf.setFont(undefined, "bold");
                pdf.setTextColor(55, 65, 81);
                pdf.text("Foto " + (index + 1) + " de " + imagenes.length, margin, y);
                pdf.setTextColor(0, 0, 0);
                y += 8;
              }
              const imgMaxH = index === 0 ? maxH : pageHeight - 45;
              const ratio = Math.min(maxW / img.width, imgMaxH / img.height);
              const imgW = img.width * ratio;
              const imgH = img.height * ratio;
              // Sombra
              pdf.setFillColor(230, 230, 230);
              pdf.roundedRect(margin + 1.5, y + 1.5, imgW + 2, imgH + 2, 2, 2, "F");
              // Borde
              pdf.setDrawColor(200, 200, 200);
              pdf.roundedRect(margin, y, imgW + 2, imgH + 2, 2, 2, "S");
              pdf.addImage(img, "JPEG", margin + 1, y + 1, imgW, imgH);
              loaded++;
              if (loaded < imagenes.length) { agregarImagen(loaded); }
              else { addFooter(imagenes.length); setPdfNombre(nombrePdf); setPdfUrl(pdf.output("bloburl")); setGenerandoPdf(false); }
            };
            img.onerror = () => {
              loaded++;
              if (loaded < imagenes.length) { agregarImagen(loaded); }
              else { addFooter(imagenes.length); setPdfNombre(nombrePdf); setPdfUrl(pdf.output("bloburl")); setGenerandoPdf(false); }
            };
            img.src = imgSrc;
          };
          agregarImagen(0);
        } else {
          pdf.setFillColor(255, 243, 205);
          pdf.roundedRect(margin, y, pageWidth - margin * 2, 12, 2, 2, "F");
          pdf.setFontSize(10);
          pdf.setTextColor(120, 100, 0);
          pdf.text("⚠ No se encontró evidencia fotográfica para este GPS.", margin + 4, y + 8);
          pdf.setTextColor(0, 0, 0);
          setPdfNombre(nombrePdf); setPdfUrl(pdf.output("bloburl"));
          setGenerandoPdf(false);
        }
  };

  return (
    <SiteWrapper>
      <style>{`
        @keyframes gps-pulse {
          0%, 100% { transform: scale(1); opacity: 1; box-shadow: 0 0 8px rgba(220,38,38,0.6); }
          50% { transform: scale(1.08); opacity: 0.85; box-shadow: 0 0 18px rgba(220,38,38,0.9); }
        }
        .gps-warning-pulse { animation: gps-pulse 1.2s ease-in-out infinite; }
      `}</style>
      <Grid.Row>
        <Grid.Col width={12}>
          <Card>
            <Card.Header>
              <Card.Title>GPS Por Devolución</Card.Title>
              <Card.Options>
              </Card.Options>
            </Card.Header>
            <Card.Body>
              {generandoPdf && (
                <div style={{
                  position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                  backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999,
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <div style={{
                    background: "#fff", borderRadius: 12, padding: "30px 40px",
                    textAlign: "center", boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                    maxWidth: 400, width: "90%"
                  }}>
                    <div style={{
                      marginBottom: 20,
                      animation: "truck-move 2s ease-in-out infinite alternate"
                    }}>
                      <img src="/images/camion.png" alt="Camión" style={{ width: 120, height: "auto" }} />
                    </div>
                    <div style={{
                      width: "60%", height: 8, backgroundColor: "#e5e7eb",
                      borderRadius: 4, overflow: "hidden", margin: "0 auto 20px"
                    }}>
                      <div style={{
                        height: "100%", width: "100%",
                        background: "linear-gradient(90deg, #3b82f6, #10b981)",
                        borderRadius: 4,
                        animation: "progress-pulse 1.5s ease-in-out infinite"
                      }}></div>
                    </div>
                    <div style={{ fontSize: 16, color: "#374151" }}>
                      Generando PDF...
                    </div>
                    <div style={{ fontSize: 12, color: "#6b7280", marginTop: 10 }}>
                      Por favor espere mientras se crea el archivo
                    </div>
                  </div>
                  <style>{`
                    @keyframes truck-move {
                      0% { transform: translateX(-10px); }
                      100% { transform: translateX(10px); }
                    }
                    @keyframes progress-pulse {
                      0%, 100% { opacity: 1; }
                      50% { opacity: 0.6; }
                    }
                  `}</style>
                </div>
              )}
              {pdfUrl && (
                <div style={{
                  position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                  backgroundColor: "rgba(0,0,0,0.4)", backdropFilter: "blur(6px)",
                  WebkitBackdropFilter: "blur(6px)", zIndex: 9999,
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <div style={{
                    background: "#1f2937", borderRadius: 12, width: 750, maxWidth: "95%", height: "85%",
                    display: "flex", flexDirection: "column", boxShadow: "0 20px 60px rgba(0,0,0,0.5)"
                  }}>
                    <div style={{
                      display: "flex", justifyContent: "space-between", alignItems: "center",
                      padding: "12px 20px", borderBottom: "1px solid #4b5563",
                      background: "#374151", borderRadius: "12px 12px 0 0"
                    }}>
                      <span style={{ fontWeight: "bold", color: "#fff", fontSize: 16 }}>Evidencia GPS - PDF</span>
                      <div style={{ display: "flex", gap: 12 }}>
                        <span title="Descargar PDF" style={{ cursor: "pointer", color: "#d1d5db", fontSize: 24 }} onClick={async () => {
                          try {
                            const resp = await fetch(pdfUrl);
                            const blob = await resp.blob();
                            if (window.showSaveFilePicker) {
                              const handle = await window.showSaveFilePicker({ suggestedName: pdfNombre, types: [{ description: "PDF", accept: { "application/pdf": [".pdf"] } }] });
                              const writable = await handle.createWritable();
                              await writable.write(blob);
                              await writable.close();
                            } else {
                              const a = document.createElement("a");
                              a.href = URL.createObjectURL(blob);
                              a.download = pdfNombre;
                              a.click();
                              URL.revokeObjectURL(a.href);
                            }
                          } catch (e) { /* usuario canceló */ }
                        }}>
                          <Icon name="download" />
                        </span>
                        <span title="Cerrar" style={{ cursor: "pointer", color: "#d1d5db", fontSize: 24 }} onClick={() => setPdfUrl(null)}>
                          <Icon name="x" />
                        </span>
                      </div>
                    </div>
                    <div style={{ flex: 1, overflow: "hidden", borderRadius: "0 0 12px 12px", background: "#525659", padding: 8 }}>
                      <iframe
                        src={pdfUrl + "#toolbar=0"}
                        title="PDF Evidencia"
                        style={{ width: "100%", height: "100%", border: "none" }}
                      />
                    </div>
                  </div>
                  <style>{`
                    .pdf-scroll-container::-webkit-scrollbar { width: 8px; }
                    .pdf-scroll-container::-webkit-scrollbar-track { background: #374151; border-radius: 4px; }
                    .pdf-scroll-container::-webkit-scrollbar-thumb { background: #6b7280; border-radius: 4px; }
                    .pdf-scroll-container::-webkit-scrollbar-thumb:hover { background: #9ca3af; }
                  `}</style>
                </div>
              )}
              {!cargando && gpsList.length > 0 && (
                <h2 style={{ textAlign: "center", color: "#374151", fontWeight: "bold", marginBottom: "20px" }}>
                  {gpsList.length} GPS Pendientes
                </h2>
              )}
              {cargando ? (
                <TableSkeleton
                  headers={["Días sin Recuperar", "GPS", "IMEI", "ID Último Mov.", "Estatus", "Plataforma", "Corredor", "Localidad", "Transportista", "Cliente", "Placa Remolque", "Eco Remolque", "Placa Tracto", "Eco Tracto", "Fecha Colocación", "Última Actividad", "Fin de Movimiento", "Evidencia"]}
                  title="GPS Pendientes"
                  rows={10}
                />
              ) : gpsList.length === 0 ? (
                <div className="text-center text-muted py-5">
                  <p>No hay GPS pendientes por devolver.</p>
                </div>
              ) : (
                <TablePageable
                  lista={gpsList}
                  columnas={[
                    { columna: "diasSinRecuperar", label: "Días sin Recuperar", form: (item) => {
                      const dias = item.diasSinRecuperar;
                      if (typeof dias === "number" && dias > 10) {
                        return (
                          <span className="gps-warning-pulse" style={{ background: "#dc2626", color: "#fff", padding: "4px 10px", borderRadius: 20, fontWeight: "bold", fontSize: 13, display: "inline-flex", alignItems: "center", gap: 4, boxShadow: "0 0 8px rgba(220,38,38,0.6)" }}>
                            ⚠ {dias} días
                          </span>
                        );
                      }
                      return dias;
                    }},
                    {
                      columna: "idGps",
                      label: "Evidencia",
                      form: (item) => (
                        <Button size="sm" color="primary" title="Ver PDF" onClick={() => generarPdfEvidencia(item)} disabled={generandoPdf} style={{ padding: "4px 8px" }}>
                          <Icon name="file-text" />
                        </Button>
                      )
                    },
                    { columna: "gps", label: "GPS" },
                    { columna: "imei", label: "IMEI" },
                    { columna: "idMovimiento", label: "ID Último Mov.", form: (item) => item.idMovimiento || item.idMovimientoGps || "N/A" },
                    { columna: "gpsEstatus", label: "Estatus", form: (item) => item.gpsEstatus || item.idGpsEstatus?.nombre || "N/A" },
                    { columna: "plataforma", label: "Plataforma", form: (item) => item.plataforma || item.idPlataforma?.nombre || "N/A" },

                    { columna: "idLocalidad", label: "Localidad", form: (item) => item.idLocalidad?.nombre || "N/A" },

                    { columna: "cliente", label: "Cliente", form: (item) => item.cliente || item.idCliente?.nombre || "N/A" },
                    { columna: "remolquePlaca", label: "Placa Remolque" },
                    { columna: "economicor", label: "Eco Remolque" },
                    { columna: "tractorPlaca", label: "Placa Tracto" },
                    { columna: "economicot", label: "Eco Tracto" },
                    { columna: "colocacionFecha", label: "Fecha Colocación", form: (item) => { const f = item.colocacionFecha; if (!f) return "N/A"; const d = new Date(f); return isNaN(d.getTime()) ? String(f) : d.toLocaleString("es-MX"); } },
                    { columna: "endDate", label: "Fin de Movimiento", valor: (item) => { const f = item.endDateFormatted || item.endDate; if (!f) return "N/A"; const d = new Date(f); return isNaN(d.getTime()) ? String(f) : d.toLocaleString("es-MX"); }, form: (item) => { const f = item.endDateFormatted || item.endDate; if (!f) return "N/A"; const d = new Date(f); return isNaN(d.getTime()) ? String(f) : d.toLocaleString("es-MX"); } },
                    { columna: "deviceactivity", label: "Última Actividad", valor: (item) => { const f = item.deviceactivityFormatted || item.deviceactivity; if (!f) return "N/A"; const d = new Date(f); return isNaN(d.getTime()) ? String(f) : d.toLocaleString("es-MX"); }, form: (item) => { const f = item.deviceactivityFormatted || item.deviceactivity; if (!f) return "N/A"; const d = new Date(f); return isNaN(d.getTime()) ? String(f) : d.toLocaleString("es-MX"); } }
                  ]}
                  id="idGps"
                  paginacion={true}
                  elementosPorPagina={20}
                  csvname="GPS_Por_Devolucion"
                />
              )}
            </Card.Body>
          </Card>
        </Grid.Col>
      </Grid.Row>
    </SiteWrapper>
  );
};

export default GpsDevolucionPage;